/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DeadlineInputs */

const cs_enum_deadline = /** @type {(inputs: Enum_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín`)
};

const en_enum_deadline = /** @type {(inputs: Enum_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deadline`)
};

/**
* | output |
* | --- |
* | "Deadline" |
*
* @param {Enum_DeadlineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deadline = /** @type {((inputs?: Enum_DeadlineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DeadlineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deadline(inputs)
	return cs_enum_deadline(inputs)
});